// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiDrawer } from 'ui-components/ui-drawer/UiDrawer';
import { scrollbar } from 'utils';

export const StyledMobileDrawer = styled(UiDrawer)(
  () => css`
    &.profile-menu {
      &.tablet-popup,
      &.mobile-drawer {
        display: none;
      }
    }

    @media only screen and (max-width: 1095px) {
      &.profile-menu {
        &.tablet-popup {
          display: block;
          width: 260px;
          .menu-wrapper {
            border-radius: 16px;
          }
        }
        .MuiDrawer-paper {
          border: 1px solid #e2e2ea;
          border-radius: 16px 16px 0 0;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
        }

        .menu-wrapper {
          box-sizing: border-box;
          background: #ffffff;
          z-index: 99;
          font-weight: 700;
          font-size: 0.87rem;
          line-height: 1.5rem;

          .icon {
            font-weight: normal;
          }

          .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 32px;
            padding: 16px 16px 0;

            &.step-header {
              padding: 20px 16px 16px;
              margin-bottom: 0;
              border-bottom: 1px solid #ccd5dc;
            }

            .header-close {
              display: none;
              margin-right: 8px;
              cursor: pointer;
            }

            .header-info {
              display: flex;
              align-items: center;
              overflow: hidden;

              .avatar {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background: #eeeef2;
                border: 1px solid #e2e2ea;
                object-fit: cover;
                flex-shrink: 0;
              }

              .info-avatar {
                margin-right: 0 !important;
              }

              .label {
                margin-right: 8px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .icon {
                cursor: pointer;
              }
            }
          }

          .modal-body {
            padding: 0 16px 8px;
            max-height: 70vh;
            overflow: auto;
            overflow-x: hidden;
            ${scrollbar(0)};
            &:hover {
              ${scrollbar(0, '#9b9ea0')};
            }

            &--link {
              display: flex;
              align-items: center;
              cursor: pointer;
              padding: 10px 0;
              color: #6c879b;
              width: max-content;

              .icon {
                margin-left: 8px;
              }

              &:hover {
                color: #566d7e;
              }
            }

            .hr {
              display: none;
            }

            .file-is-ready {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }

            .message {
              margin-right: 0;
              margin-top: 0;
            }

            .file-name {
              margin: 5px 0;
            }

            .change-Password-Notif {
              margin-bottom: 5px;

              &:last-child {
                margin-bottom: 0;
              }
            }

            .excel-notif,
            .pdf-notif {
              margin: 5px 0 10px;

              &:last-child {
                margin-bottom: 0;
              }
            }

            .modal-main-actions {
              margin-bottom: 22px;
              color: #4c6fff;

              .action-item {
                display: flex;
                cursor: pointer;
                padding: 10px;
                width: max-content;

                .item-icon {
                  margin-left: 16px;
                  position: relative;

                  .icon-flag {
                    background-color: #f7936f;
                    border: 2px solid #ffffff;
                    border-radius: 11px;
                    padding: 0 4px;
                    position: absolute;
                    top: -8px;
                    right: -12px;
                    color: #ffffff;
                    font-weight: 400;
                    font-size: 0.65rem;
                    line-height: 0.9rem;
                  }
                }

                &:hover {
                  color: #1946ff;
                  .icon {
                    color: #1946ff;
                  }
                }
              }
            }

            .quick-guide.is-mobile {
              padding: 8px;
              background-color: #e1e8ff;
              margin: 8px 0 16px;
              border-radius: 16px;
            }

            .body-ability,
            .body-support {
              font-weight: 400;
              font-size: 0.75rem;
              line-height: 1.5rem;
              color: #000000;

              .button--wrapper {
                margin-top: 8px;
                display: flex;
                justify-content: space-between;
                .blog-link {
                  width: 100%;
                }
                .textbox {
                  .MuiOutlinedInput-multiline {
                    padding: 14px;
                  }
                  textarea {
                    font-size: 0.87rem;
                  }
                }

                .MuiButton-root {
                  width: 100%;
                }
              }
            }

            .body-support {
              margin-top: 24px;
            }
          }

          .modal-footer {
            padding: 0 16px 16px;
            .modal-main-actions {
              display: none;
            }
          }
        }
      }
    }

    @media only screen and (max-width: 600px) {
      &.profile-menu {
        &.mobile-drawer {
          display: block;
        }
        &.tablet-popup {
          display: none;
        }
        .MuiDrawer-paper {
          .menu-wrapper {
            border-radius: 16px 16px 0 0;

            .modal-header {
              .header-close {
                display: block;
              }
            }

            .modal-body {
              .modal-main-actions {
                display: none;
              }
            }

            .modal-footer {
              padding: 0 16px 32px;
              display: block;
              .modal-main-actions {
                display: flex;
                justify-content: space-around;
                margin-top: 30px;
                color: #4c6fff;
                .action-item {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  cursor: pointer;
                  .item-icon {
                    margin-bottom: 12px;
                    text-align: center;
                    position: relative;
                    .icon-flag {
                      background-color: #f7936f;
                      border: 2px solid #ffffff;
                      border-radius: 11px;
                      padding: 0 4px;
                      position: absolute;
                      top: -7px;
                      right: -3px;
                      color: #ffffff;
                      font-weight: 400;
                      font-size: 0.65rem;
                      line-height: 0.9rem;
                    }
                  }
                  &:hover {
                    color: #1946ff;
                    .icon {
                      color: #1946ff;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
);
